import { hideAnnualReceiptBanner } from './headerTaxReceiptBanner';
import { toggleSignInOverlay } from './toggleSigninOverlay';
import { refreshMiniCartFromServerOrLocalStorage } from './miniCartFunctions';
import { isLoggedInOrRemembered } from '../../utils/isLoggedIn';

export const addEventHandlersToHeaderElements = function () {
    $('.js-header-link-sign-in').on('click', toggleSignInOverlay);
    $('.js-header-link-greeting').on('click', toggleDonorAccountInfo);
    $('.js-hide-annual-receipt-banner').on('click', hideAnnualReceiptBanner);
    $('.js-hide-teacher-email-confirm-banner').on('click', hideTeacherEmailConfirmBanner);
    $('.js-hide-match-code').on('click', hideMatchCode);
    $('.js-hide-teacher-school-email-confirm-banner').on('click', hideTeacherSchoolEmailConfirmBanner);
    $('.js-hide-teacher-banner').on('click', hideTeacherBanner);
    $('.js-mobile-menu').on('click', toggleMenuLinks);
};

export function toggleDonorAccountInfo() {
    $('#mainHeader').toggleClass('stackup');
    if ($('#account-trigger').hasClass('disabled')) {
        return;
    }
    const visible = $('#user-account-links .subnav').is(':visible');
    hideAccountDropdowns();
    if (!visible) {
        $('#user-account-links .subnav').show();
        $('#account-trigger').addClass('triggered');
    }
    return window.returnFalse();
}

function hideTeacherEmailConfirmBanner() {
    $('#teacher-email-confirm-banner').hide();
    window.eraseCookie('teacherEmailConfirm');
}

function hideTeacherSchoolEmailConfirmBanner() {
    $('#teacher-school-email-confirm-banner').hide();
    window.eraseCookie('teacherSchoolEmailConfirm');
}

function hideMatchCode() {
    window.createCookie('xMatchCode', 'true', 365);
    $('.newbie-banner.match-code').hide();
}

function hideTeacherBanner() {
    window.createCookie('xTeacherBanner', 'true', 365);
    $('#teacher-banner').hide();
}

function toggleMenuLinks() {
    $('#main-header').slideToggle(300);
}

export const closeMenuLinks = function (duration?: number) {
    $('#main-header').slideUp(duration);
};

export const initHeaderElements = function () {
    if (document.getElementById('account-links')) {
        window.setUpUserCookies();
        personalizeHeaderElements();
    }
};

function teacherHasAuthorityToUploadProfilePhoto() {
    if (!isLoggedInOrRemembered()) {
        return false;
    }
    // [2017-02-02, BGK] for Teacher Profile and Project Page
    // eslint-disable-next-line eqeqeq
    if (window.teacherId && window.userId != window.teacherId) {
        return false;
    }
    // [2017-02-02, BGK] for Giving Page
    // eslint-disable-next-line eqeqeq
    if (window.challenge && window.challenge.donorId && window.userId != window.challenge.donorId) {
        return false;
    }
    return true;
}

export function toggleTeacherProfilePhotoUploadOverlay(event: Event) {
    // make sure teacher can't upload photo if they signed out in an another tab
    $(window).off('userCookiesReset.toggleTeacherProfilePhotoUploadOverlay');
    if (!teacherHasAuthorityToUploadProfilePhoto()) {
        toggleSignInOverlay(null, true);
        $(window).on('userCookiesReset.toggleTeacherProfilePhotoUploadOverlay', function () { toggleTeacherProfilePhotoUploadOverlay(event); });
        return;
    }
    if (event) {
        event.preventDefault ? event.preventDefault() : event.returnValue = false;
    }

    // no overlay on mobile
    if (window.isMobileView()) {
        location.href = secureBaseURL + 'teacher/profile_photo_upload.html?endpointURL=' + encodeURIComponent(location.href);
        return;
    }
    const iframeId = 'teacher-profile-photo-overlay-iframe';
    if ($('#' + iframeId).length === 0) {
        window.toggleAndPositionScreenAndOverlayIframe(iframeId, secureBaseURL + 'teacher/profile_photo_upload.html', event);
        $('.overlay-iframe-wrapper').addClass('overlay').addClass('large');
    }
}

export const showHideTeacherEmailConfirmBanner = function () {
    if (window.isNonBlankCookie('teacherEmailConfirm') && window.readCookie('teacherEmailConfirm') === 'true') {
        $('#teacher-email-confirm-banner').show();
        $('#teacher-banner').hide();
    } else {
        $('#teacher-email-confirm-banner').hide();
    }
};

export const showHideTeacherSchoolEmailConfirmBanner = function () {
    if (window.isNonBlankCookie('teacherSchoolEmailConfirm') && window.readCookie('teacherSchoolEmailConfirm') === 'true') {
        $('#teacher-school-email-confirm-banner').show();
        $('#teacher-school-email-confirm-banner .screen').addClass('on');
        $('#teacher-school-email-confirm-banner .overlay').addClass('on');
        $('#teacher-banner').hide();
    } else {
        $('#teacher-school-email-confirm-banner').hide();
    }
};

export const setHeaderMMILink = function () {
    if (window.readCookie('favCookiesSet') != null) {
        if (window.readCookie('favCookiesSet') === 'true') {
            $('.donor-tabs .favorites').addClass('on');
        } else {
            $('.donor-tabs .favorites').removeClass('on');
        }
    }
    if (window.isNonBlankCookie('hasViewableGPs') && window.readCookie('hasViewableGPs') === 'true') {
        $('.donor-tabs .donor-campaigns').addClass('on');
    } else {
        $('.donor-tabs .donor-campaigns').removeClass('on');
    }
};

function hideAccountDropdowns() {
    $('#teacher-account-links .subnav').hide();
    $('#user-account-links .subnav').hide();
    $('#account-trigger').removeClass('triggered');
    $('#classroom-trigger').removeClass('triggered');
}

// same as signout
function notYou(event: JQuery.Event) {
    window.eraseCookie('userId');
    window.resetUserVariables();
    window.eraseCookie('cartUUID');
    window.eraseCookie('accountCredits');
    window.eraseCookie('cartGiftCodeAmount');
    window.eraseCookie('headerinfo');
    window.resetMiniCart();
    window.removeFavorites();
    window.displayAccountCreditsTip(); // hide account credits tip
    window.showSignOutLink();
    hideAccountDropdowns();
    if (window.signinOverlay2Part) {
        window.signinOverlay2Part.reinitialize();
    }

    if (event) event.preventDefault();
    window.getURLInHiddenIframe(secureBaseURL + 'common/signout.html', 'notYouIframe');
}

function personalizeHeaderElements() {
    refreshMiniCartFromServerOrLocalStorage();
    window.showSignOutLink();
}

export const resetAndPersonalizeHeaderElements = function () {
    window.setUpUserCookies();
    personalizeHeaderElements();
    window.refreshAccountCredits();
};

export const addEventHandlersToUserTabs = function () {
    $('.js-donor-tabs .js-sign-out').on('click', function (event) {
        notYou(event);
    });
};
